export const MONTHS = [
  { value: 0, label: 'January' },
  { value: 1, label: 'February' },
  { value: 2, label: 'March' },
  { value: 3, label: 'April' },
  { value: 4, label: 'May' },
  { value: 5, label: 'June' },
  { value: 6, label: 'July' },
  { value: 7, label: 'August' },
  { value: 8, label: 'September' },
  { value: 9, label: 'October' },
  { value: 10, label: 'November' },
  { value: 11, label: 'December' }
] as const;

export function getYearsRange(currentYear?: number, range: number = 10): number[] {
  const year = currentYear || new Date().getFullYear();
  const years: number[] = [];
  for (let i = year - range; i <= year + range; i++) {
    years.push(i);
  }
  return years;
}
